import React from 'react'
import styled from 'styled-components'
import { device } from '../../../../config/theme/breakpoints';
import TitleSection from '../../../../components/title-section/title-section';
import { listOptions } from '../../data';
import ItemOption from '../../../services/components/item-option/item-option';
import image from '../../../../assets/img/item_service.png'

const GeneralCenter = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
`

const ContainerItem = styled(GeneralCenter)`
    width: 100%;
    background: #F2F2F2;
    padding: 30px;
    margin-top: 20px;
    margin-bottom: 0px;
    flex-wrap: wrap;
    border-radius: 15px;
    align-items: flex-start;
`

const ContainerLeft = styled(GeneralCenter)`
    width: 100%;
    flex-direction: column;
    align-items: flex-start;

    > div:nth-child(2){
        margin-top: 20px;
    }

    @media ${device.tablet}{
        width: 40%;
    }
`
const ContainerRight = styled.div`
    width: 100%;
    padding-left: 0; 

    @media ${device.tablet}{
        width: 58%;
        padding-left: 25px;
    }
`

const ContainerImage = styled.div`
    width: 100%;

    > img {
        width: 100%;
        border-radius: 10px 10px 100px 10px;
        border-bottom: 5px solid ${p => p.theme.palette.secondary.main};
    }
`

const ContainerText = styled.div`
    > h2, h4, p{
        margin: 0;
        margin-bottom: 5px;
    }

    > h4 {
        color: ${p => p.theme.palette.secondary.main}
    }

    > h2 {
        color: ${p => p.theme.palette.primary.main}
    }

    > p {
        color: ${p => p.theme.palette.text.black};
        font-size: 13px;
        margin-top: 20px;
    }
`

const ContainerOptions = styled.div`
    display: flex;
    align-items: flex-start;
    width: 100%;
    flex-wrap: wrap;
    margin-top: 10px;

    @media ${device.mobileL}{
        width: 50%;
    }
`
const customTitle = `
    margin-top: 20px;

    @media ${device.tablet}{
        margin-top: 0;
    }
`

const ItemServiceDetail: React.FunctionComponent = () => {
  return (
    <ContainerItem>
        <ContainerLeft>
            <ContainerImage>
                <img src={image} alt='bus' />
            </ContainerImage>
        </ContainerLeft>
        <ContainerRight>
            <ContainerText>
                <TitleSection preTitle='Servicios' title='Panoramico' className={customTitle}/>
                <p>Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book.</p>
            </ContainerText>
            <ContainerOptions>
                {listOptions.map(option => (
                    <ItemOption key={option.id} icon={option.icon} name={option.name}/>
                ))}
            </ContainerOptions>
        </ContainerRight>
    </ContainerItem>
  )
}

export default ItemServiceDetail;